import { useEffect, useState } from "react";
import { lambdaErrorCheck } from "../../common/util/errorHandling";
import { useAppSelector } from "../../store";
import { storedLocale } from "../Authentication/util";
import type { CsiOverviewResponse } from "../../services/CustomerSalesIncentive/CustomerSalesIncentive.types";
import { useGetCsiOverviewQuery } from "../../services/CustomerSalesIncentive/CustomerSalesIncentive";

export const defaultCsiOverviewData = (): CsiOverviewResponse => {
  return {
    BannerTile: {
      CSILevel: 0,
      CSIBonus: 0,
      CSIBonusCurrency: "",
      CSIBonusCapValue: null,
      CSIBonusCapCurrency: null,
      ProgramActive: false,
      ManualApproval: false,
      IsManuallyDenied: false,
      Graduated: false,
      Earning: false,
      Denied: false,
      Held: false,
      EligibilityMet: null,
      EligibilityEndPeriod: "",
      VerifiedCustomerBV: 0,
      TotalBonusLevel: 0,
      MaxCSILevel: 0,
      MaxPerfBonusLevel: 0,
      HasPPVRequirement: false,
      TargetPPV: 0,
      CurrentPPV: 0,
      PPVRequirementMet: false,
      PPVExemptionApplied: false,
    },
    Requirements: {
      VolumeRequirements: [],
      PercentRequirements: [],
      BadgeRequirements: [],
    },
    DisplayRequirementTiles: false,
    BonusSchedules: {
      CSIBonusSchedule: [],
      PerfBonusSchedules: [],
    },
    PerformanceBonus: {
      PerfBonus: 0,
      PerfBonusCurrency: "",
      PerfBonusLevel: 0,
      CurrentGPV: 0,
    },
    TransactionHistory: null,
    CallResults: [],
    Error: null,
  };
};

export const useCsiOverviewData = (period: string, skip: boolean) => {
  const { user } = useAppSelector((state) => state.boot);
  const {
    data: payloadData,
    isFetching,
    isError,
    refetch,
  } = useGetCsiOverviewQuery(
    {
      abo: user.abo,
      aff: user.aff,
      period: period,
      locale: storedLocale(),
    },
    { skip },
  );

  const [isLoading, setIsLoading] = useState(true);
  const [errorStatus, setErrorStatus] = useState(false);
  const [csiOverviewData, setCsiOverviewData] = useState<CsiOverviewResponse>(defaultCsiOverviewData());

  useEffect(() => {
    setIsLoading(isFetching);
    setErrorStatus(isError);
    if (!isFetching && !isError && payloadData) {
      setCsiOverviewData({
        ...payloadData,
        TransactionHistory: payloadData.TransactionHistory ?? null,
      });
      const foundLambdaError = lambdaErrorCheck(payloadData.Error);
      setErrorStatus(foundLambdaError);
    }
  }, [isFetching, period, isError, payloadData]);

  return { isLoading, csiOverviewData, errorStatus, refetch };
};
